/**
 * 水印工具函数
 */

/**
 * 创建水印
 * @param {String} text - 水印文本
 * @param {Object} options - 配置选项
 */
export function createWatermark(text, options = {}) {
	const {
		fontSize = 16,
		fontColor = 'rgba(0, 0, 0, 0.15)',
		fontFamily = 'Arial',
		width = 200,
		height = 150,
		rotate = -20,
		zIndex = 9999
	} = options;

	// 移除已存在的水印
	removeWatermark();

	// 创建 canvas
	const canvas = document.createElement('canvas');
	canvas.width = width;
	canvas.height = height;
	const ctx = canvas.getContext('2d');

	// 设置字体样式
	ctx.font = `${fontSize}px ${fontFamily}`;
	ctx.fillStyle = fontColor;
	ctx.textAlign = 'center';
	ctx.textBaseline = 'middle';

	// 旋转画布
	ctx.translate(width / 2, height / 2);
	ctx.rotate((rotate * Math.PI) / 180);
	ctx.translate(-width / 2, -height / 2);

	// 绘制文本
	ctx.fillText(text, width / 2, height / 2);

	// 创建水印容器
	const watermarkDiv = document.createElement('div');
	watermarkDiv.id = 'watermark-container';
	watermarkDiv.style.position = 'fixed';
	watermarkDiv.style.top = '0';
	watermarkDiv.style.left = '0';
	watermarkDiv.style.width = '100%';
	watermarkDiv.style.height = '100%';
	watermarkDiv.style.pointerEvents = 'none';
	watermarkDiv.style.zIndex = zIndex;
	watermarkDiv.style.backgroundImage = `url(${canvas.toDataURL()})`;
	watermarkDiv.style.backgroundRepeat = 'repeat';
	watermarkDiv.style.backgroundPosition = '0 0';

	// 添加到 body
	document.body.appendChild(watermarkDiv);

	// 防止水印被删除（MutationObserver）
	const observer = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			if (mutation.type === 'childList') {
				const watermark = document.getElementById('watermark-container');
				if (!watermark || !document.body.contains(watermark)) {
					// 如果水印被删除，重新创建
					document.body.appendChild(watermarkDiv);
				}
			}
		});
	});

	observer.observe(document.body, {
		childList: true,
		subtree: true
	});

	// 防止通过修改样式删除水印
	const styleObserver = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
				const watermark = document.getElementById('watermark-container');
				if (watermark) {
					// 恢复样式
					watermark.style.position = 'fixed';
					watermark.style.top = '0';
					watermark.style.left = '0';
					watermark.style.width = '100%';
					watermark.style.height = '100%';
					watermark.style.pointerEvents = 'none';
					watermark.style.zIndex = zIndex;
					watermark.style.backgroundImage = `url(${canvas.toDataURL()})`;
					watermark.style.backgroundRepeat = 'repeat';
					watermark.style.backgroundPosition = '0 0';
				}
			}
		});
	});

	const watermark = document.getElementById('watermark-container');
	if (watermark) {
		styleObserver.observe(watermark, {
			attributes: true,
			attributeFilter: ['style']
		});
	}

	return {
		remove: () => {
			removeWatermark();
			observer.disconnect();
			styleObserver.disconnect();
		}
	};
}

/**
 * 移除水印
 */
export function removeWatermark() {
	const watermark = document.getElementById('watermark-container');
	if (watermark) {
		watermark.remove();
	}
}

/**
 * 创建多行水印
 * @param {Array} texts - 水印文本数组
 * @param {Object} options - 配置选项
 */
export function createMultiLineWatermark(texts, options = {}) {
	const {
		fontSize = 16,
		fontColor = 'rgba(0, 0, 0, 0.15)',
		fontFamily = 'Arial',
		width = 200,
		height = 150,
		rotate = -20,
		zIndex = 9999,
		lineHeight = 25
	} = options;

	// 移除已存在的水印
	removeWatermark();

	// 创建 canvas
	const canvas = document.createElement('canvas');
	canvas.width = width;
	canvas.height = height;
	const ctx = canvas.getContext('2d');

	// 设置字体样式
	ctx.font = `${fontSize}px ${fontFamily}`;
	ctx.fillStyle = fontColor;
	ctx.textAlign = 'center';
	ctx.textBaseline = 'middle';

	// 旋转画布
	ctx.translate(width / 2, height / 2);
	ctx.rotate((rotate * Math.PI) / 180);
	ctx.translate(-width / 2, -height / 2);

	// 绘制多行文本
	texts.forEach((text, index) => {
		const y = height / 2 - (texts.length - 1) * lineHeight / 2 + index * lineHeight;
		ctx.fillText(text, width / 2, y);
	});

	// 创建水印容器
	const watermarkDiv = document.createElement('div');
	watermarkDiv.id = 'watermark-container';
	watermarkDiv.style.position = 'fixed';
	watermarkDiv.style.top = '0';
	watermarkDiv.style.left = '0';
	watermarkDiv.style.width = '100%';
	watermarkDiv.style.height = '100%';
	watermarkDiv.style.pointerEvents = 'none';
	watermarkDiv.style.zIndex = zIndex;
	watermarkDiv.style.backgroundImage = `url(${canvas.toDataURL()})`;
	watermarkDiv.style.backgroundRepeat = 'repeat';
	watermarkDiv.style.backgroundPosition = '0 0';

	// 添加到 body
	document.body.appendChild(watermarkDiv);

	// 防止水印被删除（MutationObserver）
	const observer = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			if (mutation.type === 'childList') {
				const watermark = document.getElementById('watermark-container');
				if (!watermark || !document.body.contains(watermark)) {
					// 如果水印被删除，重新创建
					document.body.appendChild(watermarkDiv);
				}
			}
		});
	});

	observer.observe(document.body, {
		childList: true,
		subtree: true
	});

	return {
		remove: () => {
			removeWatermark();
			observer.disconnect();
		}
	};
}
